<ng-container *ngIf="userId">
  <ng-template
    [requireClaims]="{ type: 'system', value: true }"
    (requireFailed)="checkFailed = true">
    <a
      target="_blank"
      class="link-underline-light fw-light"
      [ngClass]="ngClass"
      [routerLink]="['/users/preview', userId]">{{userId}}</a>
  </ng-template>
  <span
    *ngIf="checkFailed"
    class="text-secondary fw-light"
    [ngClass]="ngClass"
  >{{userId}}<span class="fw-bold">*</span></span>
</ng-container>
